import { graphql } from "@/gql";

export const ORGANIZATION_QUERY = graphql(`
  query ORGANIZATION_QUERY($id: String!) {
    adminOrganization(id: $id) {
      id
      name
      logoUrl
      createdAt
      stripeCustomerId
      ownerMember {
        id
        fullName
        emailAddress
        avatarUrl
      }
      state
      plan {
        id
        name
      }
      members {
        edges {
          node {
            id
            fullName
            displayName
            avatarUrl
            isEnabled
            organizationRole
            createdAt
            user {
              id
            }
          }
        }
      }
    }
  }
`);
